/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react'
import ReactPlayer from "react-player/youtube"
import { useDispatch, useSelector } from 'react-redux'
import { selectLessonBySlugs } from '../../redux/courseModuleSlice'
import { Mixpanel } from '../../config/Mixpanel'
import constants from '../../utilities/constants'
import { setLastWatchedLesson } from '../../redux/nameSlice'
import { fetchUserActivityUpdate } from '../../redux/updateUserActivitySlice'
import { selectCurrentCourseId } from '../../redux/courseListSlice'
import 'rc-slider/assets/index.css';
import PlaceHolderImage from './PlaceHolderImage'
import Loader from '../../components/Loader'
import { useParams } from 'react-router-dom'


const VideoPlayer = ({ lesson_slug, videoPlayerRef, showOnboardingOverview, handleUnlock, isModalLoading }) => {

    const dispatch = useDispatch()
    const { module_slug } = useParams()
    const lessonDetails = useSelector((state) => selectLessonBySlugs(state, module_slug, lesson_slug))
    const courseId = useSelector(selectCurrentCourseId)
    const [isPlaying, setIsPlaying] = useState(true)

    useEffect(() => {
        setIsPlaying(true)
    }, [module_slug, lesson_slug])
    
    function getVideoURL(url, startTime, stopTime) {

        const urlParams = url?.split('?').length

        if (startTime > 0 && stopTime > 0)
            return `${url}${urlParams > 1 ? `&start=${startTime}&end=${stopTime}` : `?start=${startTime}&end=${stopTime}`}`
        else if (startTime === 0 && stopTime > 0)
            return `${url}${urlParams > 1 ? `&end=${stopTime}` : `?end=${stopTime}`}`
        else if (startTime > 0 && stopTime === 0)
            return `${url}${urlParams > 1 ? `&start=${startTime}` : `?start=${startTime}`}`
        return url
    }

    const updateLessonStatus = async (status) => {
        try {
            await dispatch(fetchUserActivityUpdate({
                course_id: courseId,
                module_slug,
                lesson_id: lessonDetails?.lesson_id,
                status,
            })).unwrap()
        } catch (error) {
            console.log(error.message)
        }
    }

    const handleStart = () => {
        Mixpanel.track(constants.Mixpanel.LESSON_PAGE_LESSON_WAS_PLAYED)
        dispatch(setLastWatchedLesson({ courseId, lessonId: lessonDetails?.lesson_id }))
        if (lessonDetails?.lesson_status === ""){
            updateLessonStatus("ongoing")
        }
    }

    const handleProgress = useCallback((state) => {
        const stopTime = Number(lessonDetails?.stop_time) || 0
        if (stopTime > 0 && state.playedSeconds >= stopTime) {
            videoPlayerRef.current?.seekTo(0, 'seconds')
            setIsPlaying(false)
        }
      }, [])



      if (!lessonDetails) {
        return <Loader/>
      }

    return (
        <div className='w-full lg:mx-auto lg:rounded-xl overflow-hidden flex flex-col items-center justify-center'>
            {showOnboardingOverview ? <PlaceHolderImage imageUrl={lessonDetails?.thumbnail_url} handleUnlock={handleUnlock} isModalLoading={isModalLoading}/> : <ReactPlayer
                url={getVideoURL(lessonDetails?.video_url, lessonDetails?.start_time, lessonDetails?.stop_time)}
                ref={videoPlayerRef}
                width={'100%'}
                onProgress={(e) => handleProgress(e)}
                onStart={handleStart}
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
                playing={isPlaying}
                controls={true}
                config={{
                    file: {
                        attributes: {
                            preload: 'auto',
                            poster : lessonDetails?.thumbnail_url,
                        },
                    },
                    youtube: {
                        playerVars: { modestbranding: 1, rel: 0 ,cc_load_policy:1 , cc_lang_pref:'en'},
                    },
                }}
            />}       
        </div> 
    )
}

export default VideoPlayer
